import {
  API_ENDPOINT_ADDBID,
  API_ENDPOINT_BID_BUYNOW,
  API_ENDPOINT_GETHIGHBID_BYID,
} from '../Constants';
import BaseMarketplaceService from './BaseMarketplaceService';

export default class BidsService extends BaseMarketplaceService {
  async placeBid(payload) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_ADDBID, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload || {}),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async getHighestBid(auctionId) {
    if (!auctionId) throw new Error('auctionId is required');
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_GETHIGHBID_BYID(auctionId), {
      method: 'GET',
      headers,
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async buyNow(payload) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_BID_BUYNOW, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload || {}),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }
}

